import React from "react";
import { Header, Inquiry } from "Atoms/";

export default function inquiry() {
  return (
    <>
      <Header
        classType="header-int"
        title1="Diamond Head"
        title2="State Monument"
        isHeadShow={false}
        isReserve={false}
      />
      <Inquiry />
    </>
  );
}
